import React, {useState} from "react"
import {useStore, useDispatch} from "../Store"
import {CsvReader} from "../components"
import {makeStyles} from "@material-ui/core/styles"
import {grey, pink} from "@material-ui/core/colors"
import {updateEquitySetList, updateCategoryList, getEquityUpdateStatus} from "../api"
import {getTokenCookie} from "../common"
import {useTranslation} from "react-i18next"
import "../i18n"
import {useCookies} from "react-cookie"

export default function UploadCSV({kind = null, group = null, pw = null}) {
  const [cookies] = useCookies([])
  const {t} = useTranslation()
  const {
    store: {password, tabs, mainGroup},
  } = useStore()
  const {dispatch} = useDispatch()
  const [, setCsvSetList] = useState([])

  const handleFileLoaded = async (csvSetList) => {
    let errorRecordInfoList = []
    if (csvSetList.length === 0) {
      const confirmDialog = {
        message: `指定されたCSVファイルにデータが見つかりません。`,
        state: true,
      }
      dispatch({
        type: `CONFIRM_DIALOG`,
        confirmDialog,
      })
      return
    }
    const columnNameList = {
      ...csvSetList[0],
    }
    const {
      categoryCode = null,
      categoryName = null,
      lowLimit = null,
      highLimit = null,
      updateDate = null,
      ISIN = null,
      tickerCode = null,
      equityName = null,
    } = columnNameList

    if (kind === `CATEGORY`) {
      if (!categoryCode || !categoryName || !lowLimit || !highLimit || !updateDate) {
        let emptyColumnNameList = ``
        if (!categoryCode) emptyColumnNameList += `categoryCode `
        if (!categoryName) emptyColumnNameList += `categoryName `
        if (!lowLimit) emptyColumnNameList += `lowLimit `
        if (!highLimit) emptyColumnNameList += `highLimit `
        if (!updateDate) emptyColumnNameList += `updateDate`
        const confirmDialog = {
          message: `以下のカラム名が不足しています。\n${emptyColumnNameList}`,
          state: true,
        }
        dispatch({
          type: `CONFIRM_DIALOG`,
          confirmDialog,
        })
        return
      }
    }
    if (kind === `EQUITY`) {
      if (group === mainGroup[0]) {
        if (!tickerCode || !equityName || !categoryCode || !updateDate) {
          let emptyColumnNameList = ``
          if (!tickerCode) emptyColumnNameList += `tickerCode `
          if (!equityName) emptyColumnNameList += `equityName `
          if (!lowLimit) emptyColumnNameList += `lowLimit `
          if (!highLimit) emptyColumnNameList += `highLimit `
          if (!updateDate) emptyColumnNameList += `updateDate`
          const confirmDialog = {
            message: `以下のカラム名が不足しています。\n${emptyColumnNameList}`,
            state: true,
          }
          dispatch({
            type: `CONFIRM_DIALOG`,
            confirmDialog,
          })
          return
        }
        errorRecordInfoList = csvSetList.filter((equitySet, index) => {
          const columnNameList = {
            ...equitySet,
          }
          const {tickerCode = null, equityName = null, lowLimit = null, highLimit = null, updateDate = null} = columnNameList
          if (!tickerCode || !equityName || !lowLimit || !highLimit || !updateDate) {
            return {
              recordNumber: index + 1,
              record: equitySet,
            }
          }
        })
      }
      if (group === mainGroup[1]) {
        if (!ISIN || !equityName || !categoryCode || !updateDate) {
          let emptyColumnNameList = ``
          if (!ISIN) emptyColumnNameList += `ISIN `
          if (!equityName) emptyColumnNameList += `equityName `
          if (!lowLimit) emptyColumnNameList += `lowLimit `
          if (!highLimit) emptyColumnNameList += `highLimit `
          if (!updateDate) emptyColumnNameList += `updateDate`
          const confirmDialog = {
            message: `以下のカラム名が不足しています。\n${emptyColumnNameList}`,
            state: true,
          }
          dispatch({
            type: `CONFIRM_DIALOG`,
            confirmDialog,
          })
          return
        }
        errorRecordInfoList = csvSetList.filter((equitySet, index) => {
          const columnNameList = {
            ...equitySet,
          }
          const {ISIN = null, equityName = null, lowLimit = null, highLimit = null, updateDate = null} = columnNameList
          if (!ISIN || !equityName || !lowLimit || !highLimit || !updateDate) {
            return {
              recordNumber: index + 1,
              record: equitySet,
            }
          }
        })
      }
    }

    if (errorRecordInfoList.length !== 0) {
      const confirmDialog = {
        message: `以下の行数に不足データがあります。\n${errorRecordInfoList}`,
        state: true,
      }
      dispatch({
        type: `CONFIRM_DIALOG`,
        confirmDialog,
      })
      return
    }

    const loadingModal = {
      message: `ただ今、データアップロード中です。今しばらくお待ちください。`,
      state: true,
    }
    dispatch({
      type: `LOADING_MODAL`,
      loadingModal,
    })

    const {status = null} = await getEquityUpdateStatus(getTokenCookie(cookies))
    if (status === `Done`) {
      const params = {
        group,
        list: csvSetList,
      }
      const response =
        kind === `EQUITY`
          ? await updateEquitySetList(getTokenCookie(cookies), params)
          : await updateCategoryList(getTokenCookie(cookies), params)
      if (response.status === `ok`) {
        setCsvSetList([])
        dispatch({
          type: `LOADING_MODAL`,
          loadingModal: {
            state: false,
          },
        })
        const confirmDialog = {
          message: response.message,
          state: true,
        }
        dispatch({
          type: `CONFIRM_DIALOG`,
          confirmDialog,
        })
        return
      }
    }
    if (status === `Runnig`) {
      setCsvSetList([])
      dispatch({
        type: `LOADING_MODAL`,
        loadingModal: {
          state: false,
        },
      })
      const confirmDialog =
        kind === `EQUITY`
          ? {
              message: `ただ今、構成銘柄更新処理中のため、新たな処理を受け付ける事ができません。\nもうしばらくお待ちください。`,
              state: true,
            }
          : {
              message: `ただ今、業種一覧更新処理中のため、新たな処理を受け付ける事ができません。\nもうしばらくお待ちください。`,
              state: true,
            }
      dispatch({
        type: `CONFIRM_DIALOG`,
        confirmDialog,
      })
      return
    }
    if (status === `Error`) {
      setCsvSetList([])
      dispatch({
        type: `LOADING_MODAL`,
        loadingModal: {
          state: false,
        },
      })
      const confirmDialog = {
        message: t(`error`),
        status: true,
      }
      dispatch({
        type: `CONFIRM_DIALOG`,
        confirmDialog,
      })
      return
    }
  }

  const handleFileLoadedError = (error) => {
    const confirmDialog = {
      message: `CSVファイル読み込みエラー`,
      error,
      state: true,
    }
    dispatch({
      type: `LOADING_MODAL`,
      loadingModal: {
        state: false,
      },
    })
    dispatch({
      type: `CONFIRM_DIALOG`,
      confirmDialog,
    })
    setCsvSetList([])
  }

  const useStyles = makeStyles({
    csvLabel: {
      display: `block`,
      margin: `8px 0px`,
      padding: 10,
      width: `100%`,
      color: `white`,
      backgroundColor: password === process.env.CSV_UPDATE_PW ? pink.A400 : grey[500],
      borderRadius: 4,
      cursor: `pointer`,
      transition: `background-color 0.2s`,
      "&:hover": {
        backgroundColor: password === process.env.CSV_UPDATE_PW ? pink.A200 : grey[500],
      },
    },
    csvButton: {
      display: `none`,
    },
  })
  const classes = useStyles()

  const papaparseOptions = {
    header: true,
    dynamicTyping: true,
    skipEmptyLines: true,
  }

  let label = null
  if (kind === `EQUITY`) {
    label = password === pw ? `${group}${t(`uploadEquity`)}` : `${group}${t(`uploadEquityLock`)}`
  }
  if (kind === `CATEGORY`) {
    label = password === pw ? `${group}${t(`uploadCategory`)}` : `${group}${t(`uploadCategoryLock`)}`
  }

  return (
    <CsvReader
      disabled={password !== pw}
      cssLabelClass={classes.csvLabel}
      cssInputClass={classes.csvButton}
      label={label}
      onFileLoaded={handleFileLoaded}
      onError={handleFileLoadedError}
      parserOptions={papaparseOptions}
      inputId={`${kind}${group}CSV`}
      fileEncoding="UTF8"
    />
  )
}
